import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { getInitials } from 'lib/text-display'

const MessagingAvatar = ({
  className,
  image,
  name,
  onClick = () => undefined,
  onMouseOver = () => undefined,
}) => {
  const [error, setError] = useState(false)

  useEffect(() => {
    setError(false)
  }, [image])

  const nameStr = name?.toString() || ''
  const initials = getInitials(nameStr)
  const showImage = image && !error

  return (
    <div
      className={clsx(
        'str-chat__avatar',
        'str-chat__message-sender-avatar',
        className,
        {
          'str-chat__avatar--multiple-letters': initials.length > 1,
          'str-chat__avatar--no-letters': !initials.length,
          'str-chat__avatar--one-letter': initials.length === 1,
        },
      )}
      data-testid="avatar"
      onClick={onClick}
      onMouseOver={onMouseOver}
      role="button"
      title={nameStr}
    >
      {showImage ? (
        <img
          alt={initials}
          className="str-chat__avatar-image"
          data-testid="avatar-img"
          onError={() => setError(true)}
          src={image}
        />
      ) : (
        initials.length > 0 && (
          <div
            className="str-chat__avatar-fallback"
            data-testid="avatar-fallback"
          >
            {initials}
          </div>
        )
      )}
    </div>
  )
}

export default MessagingAvatar
